/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { authSetPasswordByInvitation } from '../../axios/authSetPasswordByInvitation'
import type {
	AuthSetPasswordByInvitationError,
	AuthSetPasswordByInvitationRequest,
	AuthSetPasswordByInvitationResponse,
} from '../../types/AuthSetPasswordByInvitation'

export const authSetPasswordByInvitationMutationKey = () => [{ url: '/auth/set-password-by-invitation' }] as const

export type AuthSetPasswordByInvitationMutationKey = ReturnType<typeof authSetPasswordByInvitationMutationKey>

export type AuthSetPasswordByInvitationVariables = {
	data: AuthSetPasswordByInvitationRequest
}

/** @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::setPasswordByInvitation */
export function useAuthSetPasswordByInvitation<TContext = unknown>(
	options?: UseMutationOptions<
		AuthSetPasswordByInvitationResponse,
		AxiosError<AuthSetPasswordByInvitationError>,
		AuthSetPasswordByInvitationVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: authSetPasswordByInvitationMutationKey(),
		mutationFn: ({ data }: AuthSetPasswordByInvitationVariables) =>
			authSetPasswordByInvitation(data, config).then(res => res.data),
		...options,
	})
}
